import { render, staticRenderFns } from "./waitingStart.vue?vue&type=template&id=1ce61071&scoped=true"
import script from "./waitingStart.vue?vue&type=script&lang=js"
export * from "./waitingStart.vue?vue&type=script&lang=js"
import style0 from "./waitingStart.vue?vue&type=style&index=0&id=1ce61071&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce61071",
  null
  
)

export default component.exports